export const PERIOD = {
  ALL_TIME: 'ALL_TIME',
  LAST_WEEK: 'LAST_WEEK',
  LAST_MONTH: 'LAST_MONTH',
  LAST_YEAR: 'LAST_YEAR',
} as const;

export type Period = (typeof PERIOD)[keyof typeof PERIOD];

export const periodQueryMap = {
  week: PERIOD.LAST_WEEK,
  month: PERIOD.LAST_MONTH,
  year: PERIOD.LAST_YEAR,
  all: PERIOD.ALL_TIME,
} as const;

export const getPeriodFromQuery = (query: string | undefined): Period => {
  if (!query) return PERIOD.ALL_TIME;
  return (
    periodQueryMap[query as keyof typeof periodQueryMap] || PERIOD.ALL_TIME
  );
};
